export function NoteEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="118"
        viewBox="0 0 200 118"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M41 79C49.6667 79.6667 57 77.3333 63 72"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          d="M128.06 6.82401L74.7253 15.2715C68.1795 16.3082 63.7135 22.4551 64.7503 29.0009L74.7621 92.213C75.7988 98.7588 81.9457 103.225 88.4915 102.188L141.827 93.7406C148.373 92.7038 152.839 86.5569 151.802 80.0111L141.79 16.7991C140.753 10.2532 134.606 5.78725 128.06 6.82401Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M124 24H70C63.3726 24 58 29.3726 58 36V100C58 106.627 63.3726 112 70 112H124C130.627 112 136 106.627 136 100V36C136 29.3726 130.627 24 124 24Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M74 40L82 48L98 32"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M81 64C85 68.6667 89 68.6667 93 64"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M101 64C105 68.6667 109 68.6667 113 64"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M89 78C94.3333 82 99.6667 82 105 78"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M75.5 76.5C77.1569 76.5 78.5 75.1569 78.5 73.5C78.5 71.8431 77.1569 70.5 75.5 70.5C73.8431 70.5 72.5 71.8431 72.5 73.5C72.5 75.1569 73.8431 76.5 75.5 76.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M115.5 76.5C117.157 76.5 118.5 75.1569 118.5 73.5C118.5 71.8431 117.157 70.5 115.5 70.5C113.843 70.5 112.5 71.8431 112.5 73.5C112.5 75.1569 113.843 76.5 115.5 76.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.9"
          d="M35.0004 81C27.8384 81.8401 23.4004 77.3342 25.2333 71.5341C31.4873 72.4761 35.0344 76.528 35.0004 81Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M35.0001 81.0001C34.0581 87.2541 28.2242 89.8932 22.8781 87.1692C25.6021 81.8232 30.091 79.6211 35.0001 81.0001Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M167 54L169 59L174 61L169 63L167 68L165 63L160 61L165 59L167 54Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M47.0004 15.5999C48.4363 15.5999 49.6004 14.4358 49.6004 12.9999C49.6004 11.564 48.4363 10.3999 47.0004 10.3999C45.5644 10.3999 44.4004 11.564 44.4004 12.9999C44.4004 14.4358 45.5644 15.5999 47.0004 15.5999Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
